import DashboardLayout from '../components/DashboardLayout';
import Breadcrumb from '../components/partials/Breadcrumb';
import PriceCard from '../components/partials/PriceCard';
import { checkoutUrl } from '../constants/externalLinks';

export default function ConsultationsPage() {
  return (
    <DashboardLayout>
      <div
        className="pl-14 pr-4 py-5 md:px-10 md:py-8"
        style={{ maxWidth: 960 }}
      >
        <Breadcrumb current="Consultations" />

        {/* Hero */}
        <div className="dash-svc-hero">
          <div className="dash-svc-hero__inner">
            <p className="dash-svc-eyebrow">Consultations</p>
            <h1 className="dash-svc-title font-serif">
              One-on-one with our specialists
            </h1>
            <div className="dash-svc-lede">
              <p>
                During your consultation, our team will review your current
                asset structure: LLCs, trusts, crypto holdings, and estate
                planning. We&apos;ll walk you through exactly what&apos;s in
                place, what&apos;s missing, and your clear next steps. Simple,
                straightforward, and built entirely around your situation.
              </p>
            </div>
          </div>
        </div>

        {/* Pricing */}
        <p className="dash-svc-section-label">Book your consultation</p>
        <div className="dash-price-grid">
          <PriceCard
            name="Initial Client Consultation"
            sub="A strategic direction call"
            amount="$300"
            terms="One-time fee"
            features={[
              '30-minute consultation',
              'Conducted via Zoom or phone',
              'A clear, structured plan moving forward',
            ]}
            checkoutHref={checkoutUrl('dfo-consultation')}
            ctaGold
            featured
          />
          <PriceCard
            name="1:1 Consultation with Jake Claver"
            sub="Private session — limited availability"
            amount="By appointment"
            terms="Scheduling required"
            features={[
              'Direct time with Jake Claver',
              'Tailored to your situation',
              'Limited slots available',
            ]}
            ctaLabel="Talk with Jake Claver"
            checkoutHref={checkoutUrl('jake-consultation')}
            ctaGold
            featured
            hideCheckout
          />
        </div>
      </div>
    </DashboardLayout>
  );
}
